import {
  CURRENT_REPORT,
  CURRENT_SAVED_REPORT,
  PIN_USER_REPORT_SUCCESS,
  SAVE_USER_REPORT_SUCCESS,
  SAVE_RECENT_USER_REPORT_SUCCESS,
  DELETE_SAVED_USER_REPORT_SUCCESS,
  FETCH_USER_DATA_SUCCESS,
  GET_LAST_SC_SETS_SUCCESS,
  SAVE_DEFAULT_LAUNCH_PAGE_SUCCESS,
  CREATE_REQ_PARAM,
  FAILED_REPORTS_DEFINITIONS_REQUEST,
  SAVE_RECENT_USER_REPORT_REQUEST,
  SENT_LAST_SELECTIONS,
  USERLOADED,
  LASTSELECTIONSLOADED,
} from "../actions/types/UserActionTypes";
import { LOGGED_OUT } from "../../../../core/modules/security/redux/actions/types/SecurityActionTypes";

export const initialState = {
  currentReportCode: "",
  currentReportSavedId: "",
  userReports: [],
  userType: "I|O|C|H",
  scSets: {},
  launchPage: "",
  savedReqParams: {},
  isAdmin: "",
  roles: [],
  failedReportsDefinitions: false,
  recentSelections: {},
  lastSelections: {},
  userLoaded: false,
  lastSelectionsLoaded: false,
};

const handleFetchUserReportsSuccess = (action, state) => ({
  ...state,
  userReports: [...action.payload.userReports.reports],
  userType: action.payload.userReports.type.value,
  // eslint-disable-next-line no-nested-ternary
  launchPage:
    action.payload.userReports.launchPage === "MY"
      ? "MY_REPORTS"
      : action.payload.userReports.launchPage === "ALL"
      ? "ALL_REPORTS"
      : "APPLICATIONS",
  isAdmin: action.payload.userReports.isAdmin,
  roles: action.payload.userReports.roles,
  userLoaded: true,
});

const handleSaveUserReportSuccess = (action, state) => ({
  ...state,
  userReports: state.userReports.map((urd) => ({
    ...urd,
    reportCategories: urd.reportCategories.map((rc) => ({
      ...rc,
      reportsWithMainCategoryReference: rc.reportsWithMainCategoryReference.map(
        (report) => ({
          ...report,
          saved:
            report.reportCode === action.payload.reportCode
              ? (report.saved || []).concat([
                  {
                    ...action.payload,
                  },
                ])
              : report.saved,
        })
      ),
      reportsWithoutMainCategoryReference:
        rc.reportsWithoutMainCategoryReference.map((report) => ({
          ...report,
          saved:
            report.reportCode === action.payload.reportCode
              ? (report.saved || []).concat([
                  {
                    ...action.payload,
                  },
                ])
              : report.saved,
        })),
    })),
  })),
});

const handleSaveRecentUserReportSuccess = (action, state) => ({
  ...state,
  userReports: state.userReports.map((urd) => ({
    ...urd,
    reportCategories: urd.reportCategories.map((rc) => ({
      ...rc,
      reportsWithMainCategoryReference: rc.reportsWithMainCategoryReference.map(
        (report) => ({
          ...report,
          recent:
            report.reportCode === action.payload.reportCode
              ? { ...action.payload }
              : report.recent,
        })
      ),
      reportsWithoutMainCategoryReference:
        rc.reportsWithoutMainCategoryReference.map((report) => ({
          ...report,
          recent:
            report.reportCode === action.payload.reportCode
              ? { ...action.payload }
              : report.recent,
        })),
    })),
  })),
});

const handleDeleteSavedUserReportSuccess = (action, state) => ({
  ...state,
  userReports: state.userReports.map((urd) => ({
    ...urd,
    reportCategories: urd.reportCategories.map((rc) => ({
      ...rc,
      reportsWithMainCategoryReference: rc.reportsWithMainCategoryReference.map(
        (report) => ({
          ...report,
          saved: (report.saved || []).filter(
            (saved) => saved.id !== action.payload.savedId
          ),
        })
      ),
      reportsWithoutMainCategoryReference:
        rc.reportsWithoutMainCategoryReference.map((report) => ({
          ...report,
          saved: (report.saved || []).filter(
            (saved) => saved.id !== action.payload.savedId
          ),
        })),
    })),
  })),
});

const handlePinUserReportSuccess = (action, state) => ({
  ...state,
  userReports: state.userReports.map((urd) => ({
    ...urd,
    reportCategories: urd.reportCategories.map((rc) => ({
      ...rc,
      reportsWithMainCategoryReference: rc.reportsWithMainCategoryReference.map(
        (report) => ({
          ...report,
          pinned:
            report.reportCode === action.payload.reportCode
              ? action.payload.pinned
              : report.pinned,
        })
      ),
      reportsWithoutMainCategoryReference:
        rc.reportsWithoutMainCategoryReference.map((report) => ({
          ...report,
          pinned:
            report.reportCode === action.payload.reportCode
              ? action.payload.pinned
              : report.pinned,
        })),
    })),
  })),
});

const handleCurrentUserReport = (action, state) => ({
  ...state,
  currentReportCode: action.reportCode,
});

const handleCurrentSavedUserReport = (action, state) => ({
  ...state,
  currentReportSavedId: action.savedId,
});

const handleSaveDefaultLaunchPage = (action, state) => ({
  ...state,
  // eslint-disable-next-line no-nested-ternary
  launchPage:
    action.payload.launchPage === "ALL"
      ? "ALL_REPORTS"
      : action.payload.launchPage === "MY"
      ? "MY_REPORTS"
      : "APPLICATIONS",
});

const userReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURRENT_REPORT:
      return handleCurrentUserReport(action, state);
    case CURRENT_SAVED_REPORT:
      return handleCurrentSavedUserReport(action, state);
    case FETCH_USER_DATA_SUCCESS:
      return handleFetchUserReportsSuccess(action, state);
    case SAVE_RECENT_USER_REPORT_SUCCESS:
      return handleSaveRecentUserReportSuccess(action, state);
    case SAVE_USER_REPORT_SUCCESS:
      return handleSaveUserReportSuccess(action, state);
    case DELETE_SAVED_USER_REPORT_SUCCESS:
      return handleDeleteSavedUserReportSuccess(action, state);
    case PIN_USER_REPORT_SUCCESS:
      return handlePinUserReportSuccess(action, state);
    case GET_LAST_SC_SETS_SUCCESS:
      return {
        ...state,
        scSets: action.payload,
      };
    case CREATE_REQ_PARAM:
      return {
        ...state,
        savedReqParams: action.payload,
      };
    case SAVE_DEFAULT_LAUNCH_PAGE_SUCCESS:
      return handleSaveDefaultLaunchPage(action, state);
    case FAILED_REPORTS_DEFINITIONS_REQUEST:
      return {
        ...state,
        failedReportsDefinitions: true,
      };
    case SAVE_RECENT_USER_REPORT_REQUEST:
      return {
        ...state,
        recentSelections: action.payload,
      };
    case SENT_LAST_SELECTIONS:
      return {
        ...state,
        lastSelections: action.payload,
      };
    case USERLOADED:
      return {
        ...state,
        userLoaded: action.payload,
      };
    case LASTSELECTIONSLOADED:
      return {
        ...state,
        lastSelectionsLoaded: action.payload,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

export default userReportReducer;
